var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/async-context-safe.ts
import { getMergedContext } from "./async-context.js";
function getSafeAsyncContext() {
  try {
    return getMergedContext();
  } catch {
    return {};
  }
}
__name(getSafeAsyncContext, "getSafeAsyncContext");
export {
  getSafeAsyncContext
};
